import React from "react"
import { useNavigate } from "react-router-dom"
import { useNavigationBlock } from "../../contexts/NavigationBlock.context"
import useSidebarContext from "../../hooks/contextConsumers/useSidebarContext.hook"
import { AppRoutes } from "../../consts/appRoutes.consts"

const ReleaseVersion = ({ shouldRedirect = true, ...props }) => {
  if (!process.env.REACT_APP_RELEASE_VERSION) return null
  const navigate = useNavigate()
  const { isBlocked, setAttemptedNavigation } = useNavigationBlock()
  const { setKeyPath, setSidebarActive } = useSidebarContext()

  const redirectToChangeLog = (e) => {
    e.preventDefault()
    const navigateTo = () => {
      setKeyPath(AppRoutes.changeLog.index)
      navigate(AppRoutes.changeLog.index)
      setSidebarActive(false)
    }
    if (isBlocked) {
      return setAttemptedNavigation([true, navigateTo])
    }
    navigateTo()
  }

  return (
    <div
      {...props}
      className={`release-version-note ${props.className}`}
      onClick={(e) => {
        if (shouldRedirect) {
          redirectToChangeLog(e)
        }
      }}
    >
      {process.env.REACT_APP_RELEASE_VERSION}
    </div>
  )
}

export default ReleaseVersion
